import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BookOpenIcon, GiftIcon, DownloadIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { coverImage } from '../data/landing';
const trust = [{
  icon: BookOpenIcon,
  label: 'Ebook digital · 150 salmos'
}, {
  icon: GiftIcon,
  label: '3 bonos exclusivos'
}, {
  icon: DownloadIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Compra segura'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-57" data-mp="xanq434vpngy">
      <div className="mx-auto grid max-w-6xl gap-x-16 gap-y-7 px-5 pb-12 pt-8 text-center md:px-8 md:pt-12 lg:grid-cols-[1.1fr_0.9fr] lg:grid-rows-[auto_1fr] lg:gap-y-9 lg:pb-24 lg:pt-20 lg:text-left" data-id="element-58" data-mp="xb5w3rhcfg22">
        {/* Title sits above the cover image on mobile */}
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-59" data-mp="3d2labedjz91r">
          <h1 className="font-serif text-[2.6rem] font-semibold leading-[1.02] text-ink sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-60" data-mp="382p73hcojln9">
            El Poder de <span className="italic text-gold" data-id="element-61" data-mp="3j9u2j3pddwnx">los Salmos</span>
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted sm:text-lg md:mt-6 md:text-xl lg:mx-0" data-id="element-62" data-mp="3o7vkflb27pxt">
            Descubrí el mensaje profundo de los Salmos y fortalecé tu conexión con Dios, un día a la vez.
          </p>
        </div>

        <motion.div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-63" data-mp="3ebioegs1kzzw">
          <div className="relative mx-auto max-w-[250px] sm:max-w-xs lg:max-w-none" data-id="element-64" data-mp="2qlenwia5hgd4">
            <img src={coverImage} alt="Portada del ebook El Poder de los Salmos en tu Vida" className="w-full rounded-2xl shadow-[0_30px_80px_-30px_rgba(43,33,24,0.45)]" data-id="element-65" data-mp="2vjzmkd9r7rzg" />
          </div>
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-66" data-mp="s1rqqjt21ys6">
          <div className="flex flex-col items-center gap-3 sm:gap-4 lg:items-start" data-id="element-67" data-mp="s3ckw8bgjfpi">
            <CtaButton size="lg" href="#oferta" data-id="element-68" data-mp="naji3pzjuhg2">Sí, quiero descubrir el poder de los Salmos</CtaButton>
            <div className="flex flex-col items-center gap-1 text-xs text-muted sm:flex-row sm:gap-2 sm:text-sm" data-id="element-69" data-mp="icrp0sn64paa">
              <span className="flex" aria-label="5 de 5 estrellas" data-id="element-70" data-mp="deyjm1tovzb2">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-bright text-gold-bright" aria-hidden="true" data-id="element-71" data-mp="161szsmjh4ciq" data-mpi={i} />)}
              </span>
              Un recurso digital para acompañar tu camino de fe.
            </div>
          </div>

          <ul className="mt-8 grid grid-cols-2 gap-x-4 gap-y-3 border-t border-line pt-5 text-left sm:mt-10 sm:grid-cols-4 sm:gap-x-6 sm:pt-6" data-id="element-72" data-mp="x0cs4mk1moi7">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-xs text-ink/80 sm:text-sm" data-id="element-73" data-mp="3hqkckmtau0vh">
                <Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-74" data-mp="1xam4qoj23mxv" />
                <span data-id="element-75" data-mp="21a4ovi31ztzn">{label}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}